
import { Component, Vue, Prop, Model } from 'vue-property-decorator';
import { RigaSpedizione, Modello } from '@/models';
import dayjs, { Dayjs } from 'dayjs';
import { StoreActions, store } from '@/store';

@Component
export default class ItemListRigaSpedizione extends Vue {
    @Prop() public rigaspedizione!: RigaSpedizione;

        get headers(): any[] {
        let titoli = [];

        if(this.rigaspedizione != undefined) {
            let tipoTaglia: any = this.rigaspedizione.tipoTagliaDecodificato;
            for (let index = 1; index <= 16; index++) {
                const nomeProp = `taglia${index.toString().padStart(2, '0')}`;
                const valProp: string = tipoTaglia[nomeProp];

                let end = valProp == undefined || valProp == '';
                if(!end) {
                    titoli.push({
                        text: valProp,
                        value: valProp,
                        align: 'center',
                        sortable: false
                    });
                }
            }
        }
        titoli.push({
            text: "TOTALI",
            value: "TOTALI",
            align: 'center',
            sortable: false
        });

        return titoli;
    }
    public panel: any = 0;

    get items(): any[] {
        let rows: any[] = [];
        if(this.rigaspedizione != undefined) {
            let totSped = 0;
            let totLav = 0;
            let totProgSped = 0;

            let riga = { id: this.rigaspedizione.indice, values: [] as  any[] };


            for (let index = 1; index <= this.headers.length-1; index++) {
                const nomeProp = `qtaTaglia${index.toString().padStart(2, '0')}`;
                const lavNomeProp = `lavQtaTaglia${index.toString().padStart(2, '0')}`;
                const progSpedNomeProp = `progSpedTaglia${index.toString().padStart(2, '0')}`;
                const valProp: string = (this.rigaspedizione as any)[nomeProp].toString();

                const quantityRiga = ((this.rigaspedizione as any)[nomeProp] as number);
                const quantityLavRiga = ((this.rigaspedizione as any)[lavNomeProp] as number);
                const quantityProgSpedRiga = ((this.rigaspedizione as any)[progSpedNomeProp] as number);

                totSped += quantityRiga;
                totLav += quantityLavRiga;
                totProgSped += quantityProgSpedRiga;

                const value = {
                    value: valProp,
                    color: '',
                    fontWeight: ''
                };

                if(quantityRiga == (quantityLavRiga - quantityProgSpedRiga)){
                    value.color = "green";
                    value.fontWeight = "bold";
                } else if(quantityRiga > (quantityLavRiga - quantityProgSpedRiga)){
                    value.color = "red";
                    value.fontWeight = "bold";
                }



                riga.values.push(value);
            }

            const totaliValue = {
                    value: totSped,
                    color: '',
                    fontWeight: ''
                };
            if(totSped == (totLav - totProgSped)){
                totaliValue.color = "green";
                totaliValue.fontWeight = "bold";
            } else if(totSped > (totLav - totProgSped)){
                totaliValue.color = "red";
                totaliValue.fontWeight = "bold";
            }
            riga.values.push(totaliValue);
            rows.push(riga);
        }
        return rows;
    }
    public formatDate(date: Date | undefined): string {
        if (!date) return '';
        return dayjs(date).format('DD/MM/YYYY');
    }

    //Delete confirm dialog
    public deleteRigaDialog : boolean = false;
    public async deleteRiga(){
        const idSpedizione = store.state.spedizioneCorrente?.id;
        const idLavorazione = this.rigaspedizione.idLavorazione;
        await store.dispatch(StoreActions.EliminaRigaSpedizioneDaLavorazione, {idSpedizione, idLavorazione});
        this.deleteRigaDialog = false;
    }

    get serialiEpc(): string {
        if(this.rigaspedizione.serialiEpc){
            return this.rigaspedizione.serialiEpc.join(', ');
        } else{
            return "";
        }
    }

}
